/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    number,
    string,
    oneOfType,
} from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { useSelector } from 'react-redux';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getUserSubmittedProductFilterZipcode } from '../../../../state/ducks/App/App-Selectors';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 0 14px',
    },
    text: {
        display: 'flex',
        alignItems: 'baseline',
        minWidth: 0,
        fontSize: '14px',
        fontWeight: 300,
        color: '#000000',
    },
    resultSummary: {
        flexShrink: 0,
    },
    searchTermWrapper: {
        display: 'inline-flex',
        alignItems: 'baseline',
        minWidth: 0,
    },
    quote: {
        flexShrink: 0,
        fontWeight: 700,
    },
    highlightedSearchTerm: {
        display: 'inline-block',
        minWidth: 0,
        maxWidth: '200px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontWeight: 700,
    },
}));

const getDisplaySearchTerm = (searchTerm = '') => {
    const normalizedSearchTerm = searchTerm.replace(/\+/g, ' ');

    try {
        return decodeURIComponent(normalizedSearchTerm);
    } catch (error) {
        return normalizedSearchTerm;
    }
};

const ProductCount = ({ productCount, searchTerm }) => {
    const classes = useStyles();
    const isCollectionProductCountEnabled = useSelector(getFeatureFlag('is-collection-product-count-enabled'));
    const userSubmittedZip = useSelector(getUserSubmittedProductFilterZipcode);
    const parsedCount = Number(productCount);
    const displaySearchTerm = getDisplaySearchTerm(searchTerm);

    if (!Number.isFinite(parsedCount) || parsedCount <= 0 || !isCollectionProductCountEnabled || (userSubmittedZip && !searchTerm)) {
        return null;
    }

    const resultText = parsedCount === 1 ? 'result' : 'results';

    return (
        <div className={classes.root}>
            <Typography className={classes.text} component="div">
                <span className={classes.resultSummary}>{`${parsedCount} ${resultText}`}</span>
                {searchTerm ? (
                    <span className={classes.searchTermWrapper}>
                        <span>&nbsp;for&nbsp;</span>
                        <span className={classes.quote}>&quot;</span>
                        <span className={classes.highlightedSearchTerm} title={displaySearchTerm}>{displaySearchTerm}</span>
                        <span className={classes.quote}>&quot;</span>
                    </span>
                ) : null}
            </Typography>
        </div>
    );
};

ProductCount.propTypes = {
    productCount: oneOfType([number, string]),
    searchTerm: string,
};

ProductCount.defaultProps = {
    productCount: 0,
    searchTerm: '',
};

export default ProductCount;
